<template>
  <div class="container">
    <router-link to="/createpost" style="font-size: 14px">Go back</router-link>
    <p class="preview-header mb-4 mt-4">{{ this.blogTitle }}</p>
    <img :src="blogImageFileURL" class="img-fluid mb-5" alt="" />
    <div class="post-content ql-editor" v-html="blogHTML"></div>
  </div>
</template>

<script>
export default {
  name: "BlogPreview",
  mounted() {
    if (this.$store.state.userProfile === null) {
      this.$router.replace("/createpost");
    }
  },
  computed: {
    blogTitle() {
      return this.$store.state.blogTitle;
    },
    blogHTML() {
      return this.$store.state.blogHTML;
    },
    blogImageFileURL() {
      return this.$store.state.blogImageFileURL;
    },
  },
};
</script>

<style>
.preview-header {
  font-size: 32px;
  font-weight: bold;
}
</style>